<!-- Component can be used in microscope and periscope -->
<template>
  <div class="contents">
    <slot :validate="validate" :invalid="invalid" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, provide, type Ref } from 'vue'

import { REGISTER_VALIDATION_HANDLER, UNREGISTER_VALIDATION_HANDLER } from './AppValidationGroup.types'

import type { ValidationHandler } from './AppValidationGroup.types'

type ValidationHandlersStorage = { id: Symbol; validate: ValidationHandler; errorMessages: Ref<string[]> }[]

const validationHandlers = ref<ValidationHandlersStorage>([])
const invalid = computed(() => validationHandlers.value.some((h) => h.errorMessages.length > 0))

provide(REGISTER_VALIDATION_HANDLER, (h) => {
  if (!validationHandlers.value.some((handler) => handler.id === h.id)) {
    // @ts-ignore
    validationHandlers.value.push(h)
  }
})

provide(UNREGISTER_VALIDATION_HANDLER, (id) => {
  const indexOfValidationHandler = validationHandlers.value.findIndex((handler) => handler.id === id)

  if (indexOfValidationHandler !== -1) {
    validationHandlers.value.splice(indexOfValidationHandler, 1)
  }
})

const validate = async (callback: () => void) => {
  const focusOnError = ref(true)

  await Promise.all(validationHandlers.value.map(async (r) => await r.validate({ focusOnError })))

  if (!invalid.value && callback) {
    callback()
  }
}
</script>
